import { render } from "./SideMenu.vue?vue&type=template&id=0aab1a82&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=0aab1a82&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aab1a82"]])

export default __exports__